import React, { PropsWithChildren } from 'react';
import { IAccordionProps } from './accordion.models';
import styles from './accordion.module.css';
import classNames from 'classnames';
import CircleChevronIcon from '../../design/icons/circle-chevron.icon';

export default function Accordion({ header, children, borderLeftColor }: PropsWithChildren<IAccordionProps>) {
  function handleKeyDown(event: React.KeyboardEvent<HTMLElement>) {
    if (event.key === 'Enter') {
      event.preventDefault();
      const details = event.currentTarget as HTMLDetailsElement;
      details.open = !details.open;
    }
  }

  return (
    <details className={classNames('card', styles.details)} tabIndex={0} onKeyDown={handleKeyDown} style={{ borderLeftColor: borderLeftColor }}>
      <summary tabIndex={-1} className={styles.summary}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <div className={styles.chevron}>
            <CircleChevronIcon />
          </div>
          {header}
        </div>
      </summary>
      <div className={styles.content}>{children}</div>
    </details>
  );
}
